import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { FiltersItemModel } from '~/models/filters'

export default class FiltersWithFavorite extends BaseModel {
  static override constructorName = 'FiltersWithFavorite'

  'favorite_filters': Record<string, FiltersItemModel> = {}
  filters: Record<string, FiltersItemModel> = {}

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (isUnknownObject(data.favorite_filters)) {
        for (const key in data.favorite_filters) {
          this.favorite_filters[key] = new FiltersItemModel(data.favorite_filters[key])
        }
      }

      if (Array.isArray(data.favorite_filters) && data.favorite_filters.length === 0) {
        this.favorite_filters = {}
      }

      if (isUnknownObject(data.filters)) {
        for (const key in data.filters) {
          this.filters[key] = new FiltersItemModel(data.filters[key])
        }
      }

      if (Array.isArray(data.filters) && data.filters.length === 0) {
        this.filters = {}
      }
    }
  }
}

registerModel(FiltersWithFavorite)
